import React from 'react';
import './Cards.css';
import { Link } from 'react-router-dom';

function Cards ()  {
    return (
        
        <div>
            <div className='container text-center'>
                    <div className="row">
                        <div className="col">
                            <Link to='SelectBranch'>
                              <div className="card" style={{width: 298}}>
                                  <img src="images/et7.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text">Notes</p>
                                    </div>
                              </div>
                              </Link>
                        </div>
                        <div className="col">
                            <Link to='SelectBranchB'>
                                <div className="card" style={{width: 298}}>
                                  <img src="images/et8.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> <br/>
                                        <p className="card-text">Books</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                        <div className="col">
                            <Link to='SelectBranchP'>
                                <div className="card" style={{width: 298}}>
                                  <img src="images/et9.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> <br/>
                                        <p className="card-text">RTU Previous Year </p> <p  className='card-text' style={{marginTop:'-1rem'}}> question papers</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>            
            </div>
            <br/>
            <hr/>
        </div>

    );
}

export default Cards;
